import { savedsearchPage } from "constants/routes";
import { closeIconSvg } from "constants/svg-assets.b1";
import lottie from 'lottie-web';
import circleCheckAnimation from '@icons/animations/circle-check.json';
/**
 * Represents the "Created Save Search" modal.
 * This class is responsible for generating the HTML content of the modal and providing access to its DOM node.
 */
export default class CreatedSaveSearchModal {
  /**
   * Initializes a new instance of the `CreatedSaveSearchModal` class.
   * Sets the modal's unique ID.
   */
  constructor() {
    this.id = 'createdSaveSearchModal';
    this.savedSearchName = null;
  }

  /**
   * Opens the modal by adding the 'modal--save-search' class to its parent element.
   * This makes the modal visible on the screen.
   */
  bindEvents() {
    this.getNode()?.parentElement?.classList.add('modal--save-search');
    setTimeout(() => {
      lottie.loadAnimation({
        container: document.querySelector('#lottie-circle-check'),
        renderer: 'svg',
        loop: false,
        autoplay: true,
        animationData: circleCheckAnimation,
      });
    }, 150);
  }

  /**
   * Closes the modal by removing the 'modal--save-search' class from its parent element.
   * This hides the modal from the screen.
   */
  unbindEvents() {
    this.getNode()?.parentElement?.classList.remove('modal--save-search');
  }

  /**
   * Generates the HTML content for the "Created Save Search" modal.
   *
   * @returns {string} The HTML string representing the modal's content.
   */
  getHtml() {
    return `<div id="${this.id}" class="nhs-c-wrapper__save-search-modal" data-qa="saved-search-modal">
              <div class="nhs-c-modal-title-save-search">
                <p class="nhs-c-heading--saved-search">Search Saved</p>
                <button id="nhs_modalClose" class="nhs-c-icon__close--24" data-qa="modal-close" data-modal-close-save-search>
                  ${closeIconSvg}
                </button>
              </div>
              <div class="nhs-c-modal-content-save-search">
                <div id="lottie-circle-check" class="nhs-c-icon__check-mark--80"></div>
                <div class="nhs-c-label--black-900-body-1-medium-regular nhs-c-modal-content-text-save-search">
                  Your search has been saved! You can quickly revisit this search anytime from your 
                  <a data-saved-search-name="${this.savedSearchName}" data-dashboard-link target="_blank" class="nhs-c-label--black-1000-body-medium-regular-underline" href="${savedsearchPage}" data-qa="saved-searches-link">Saved Searches dashboard</a>.
                </div>
              </div>
              <div class="nhs-c-wrapper__save-search-modal-content-input">
                <input data-saved-search-name="${this.savedSearchName}" data-qa="search-name-display" type="text" id="search-name" class="nhs-c-wrapper__save-search-modal-input nhs-c-wrapper__save-search-modal-input--text" value="${this.savedSearchName}" readonly>
              </div>
              <div class="nhs-c-wrapper__save-search-modal-content-button">
                <button data-saved-search-name="${this.savedSearchName}" data-keep-searching-button class="nhs-c-wrapper__save-search-modal-button" data-qa="keep-searching-cta" data-modal-close-save-search>
                  Keep Searching!
                </button>
              </div>
            </div>`;
  }

  /**
   * Retrieves the DOM node of the "Created Save Search" modal.
   *
   * @returns {HTMLElement|null} The DOM node of the modal, or `null` if it does not exist.
   */
  getNode() {
    return document.getElementById(this.id);
  }
}